/**
 * Maps API login payload ({ user, accessToken, refreshToken }) to the flat
 * shape the app expects (role, client, token on the root object).
 */
export const normalizeLoginResponse = (apiData) => {
  if (!apiData || typeof apiData !== "object") {
    return {};
  }

  const token = apiData.token || apiData.accessToken;
  const refreshToken = apiData.refreshToken;

  if (apiData.role && token) {
    return {
      ...apiData,
      token,
      accessToken: apiData.accessToken || token,
      refreshToken: refreshToken ?? apiData.refreshToken,
    };
  }

  const user = apiData.user || apiData;

  return {
    ...user,
    user: apiData.user || user,
    client: user.client || apiData.client,
    token,
    accessToken: apiData.accessToken || token,
    refreshToken,
    expiresIn: apiData.expiresIn || user.expiresIn,
  };
};
